import { getUserInmails } from '@/pages/api/scribeAPIV2';
import { useQuery } from '@tanstack/react-query';
import { useQueryUser } from './useQueryUser';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';

export const useQueryNotifications = () => {
  const { data: user } = useQueryUser();
  return useQuery({
    queryKey: [GET_NOTIFICATIONS],
    enabled: !!user,
    queryFn: async () => {
      const { data } = await getUserInmails();
      return data.inmails;
    },
    refetchOnWindowFocus: true,
    // Notifications (incl. team invitations) must appear when the user returns
    // to the app. The global 1h staleTime makes the refetchOnWindowFocus above a
    // no-op; staleTime 0 lets it refetch immediately on focus instead of waiting
    // for the next poll or a manual refresh. See APP-5397.
    staleTime: 0,
    // every minute
    refetchInterval: 60000,
  });
};
